import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import { OptimizelyVariation } from '@optimizely/react-sdk';
import SignupForm from '../SignupForm';
import events from '../SignupPageContainer/events';
import { AdjustTrackEvent } from '../../modules/analytics/adjust';
import { trackEvent } from '../../modules/analytics';
import {
  Wrapper,
  OverlayWrapper,
  Overlay,
  OverlayHeaderSection,
  OverlayContent,
  SwitchToAnchor,
} from '../ImportOnboarding/styles';
import { ValuePropositions } from './components/ValuePropositions';
import { OverlayOverrideCSS, Header1, Paragraph } from '../LoginPage/styles';
import {
  Header2,
  SwitchToAnchorOverrideCSS,
  WordPressLogoContainer,
} from './styles';
import { WordPressHero } from './components/WordPressHero';
import { OptimizelyExperiment } from '../../modules/Experimentation';

function Hero({ isWordPressReferral }) {
  if (isWordPressReferral) {
    return (
      <WordPressLogoContainer>
        <WordPressHero />
      </WordPressLogoContainer>
    );
  }
  return (
    <SwitchToAnchor className={SwitchToAnchorOverrideCSS}>
      <Header2>Welcome to Anchor</Header2>
      <OptimizelyExperiment experiment="do_value_props_drive_more_signups">
        <OptimizelyVariation variation="show">
          <ValuePropositions />
        </OptimizelyVariation>
        <OptimizelyVariation variation="hide" />
        <OptimizelyVariation default>
          <ValuePropositions />
        </OptimizelyVariation>
      </OptimizelyExperiment>
    </SwitchToAnchor>
  );
}

export function SignupPage({
  error,
  routing,
  onSubmit,
  anyTouched,
  submitting,
  onClickRequestResetPassword,
  location: { search },
}) {
  const { ref } = queryString.parse(search);
  const isWordPressReferral = ref === 'wp';
  useEffect(() => {
    // Required for Floodlight tagging
    // eslint-disable-next-line no-undef
    gtag('event', 'conversion', {
      allow_custom_scripts: true,
      send_to: 'DC-9266237/ancho0/spoti00+standard',
    });

    // adjust log for viewing sign up
    trackEvent(
      null,
      { eventToken: AdjustTrackEvent.ONBOARDING_STARTED },
      // eslint-disable-next-line no-undef
      { providers: [Adjust] }
    );
  }, []);

  return (
    <Wrapper>
      <Hero isWordPressReferral={isWordPressReferral} />
      <OverlayWrapper>
        <Overlay className={OverlayOverrideCSS}>
          <OverlayHeaderSection>
            <Header1>Create your account</Header1>
            {isWordPressReferral ? (
              <Paragraph>
                Record, share, and reach listeners everywhere.
              </Paragraph>
            ) : (
              <Paragraph>
                Already have an account?{' '}
                <Link
                  data-cy="loginLink"
                  to="/login"
                  onClick={events.signUpSignInButtonClicked}
                >
                  Log in
                </Link>{' '}
                instead.
              </Paragraph>
            )}
          </OverlayHeaderSection>
          <OverlayContent>
            <SignupForm
              anyTouched={anyTouched}
              error={error}
              onSubmit={onSubmit}
              routing={routing}
              submitting={submitting}
              location={routing.location}
              onClickRequestResetPassword={onClickRequestResetPassword}
              isWordPressReferral={isWordPressReferral}
            />
          </OverlayContent>
        </Overlay>
      </OverlayWrapper>
    </Wrapper>
  );
}
